import React from 'react'
import { CrossStorageHub as CrossStorage } from 'cross-storage'

const ACTION_GET = 'get'
const ACTION_SET = 'set'
const ACTION_DELETE = 'del'

const CrossStorageHub = (props) => {
    CrossStorage.init([
        { origin: /\.exetel.com.au$/, allow: [ACTION_GET, ACTION_SET, ACTION_DELETE] },
        { origin: /:\/\/(www\.)?exetel.com.au$/, allow: [ACTION_GET, ACTION_SET, ACTION_DELETE] }
    ])

    return <div />
}

export default CrossStorageHub



// WEBPACK FOOTER //
// ./resources/js/pages/CrossStorageHub.js